import React from 'react'
import img1 from '../CodingNinjas.jpeg'

function Projects() {
    return (
<div>
<div className="mainHeadingAbout">
               PERSONAL PROJECTS
    </div>
        <div className= "expmain">
       
       
        <div className="boxeach">
  
  <div  class="flip-container" ontouchstart="this.classList.toggle('hover');">
<div class="flipper" >
<div class="front" >
  <div className="present"></div>
 <div className="halfflipcard">
  <div className="headingexp"> "MERN Stack project" </div>
  
      <div className="positionexp">  </div>
      <div className="durationexp"> Feb 2021 - present </div>

  </div>
</div>
<div class="back">
      
  <div className="contentexp"> 
  <b>Project Link</b> <a href="https://theflyingbuzz.herokuapp.com/"> Click here </a> <br></br>
<b>Tech Stack:- React front end and Mongodb atlas at backend following MERN stack</b> 
  <br></br>
  AIM: To help school and college students plan their further studies<br></br>
</div>
</div>
</div>
</div>
</div>
      
       <div className="boxeach">
  
        <div  class="flip-container" ontouchstart="this.classList.toggle('hover');">
	<div class="flipper" >
		<div class="front" >
    <div className="medical"></div>
 <div className="halfflipcard">
        <div className="headingexp"> "DPAI- Disease Prediction using Artificial Intelligence" </div>
        
            <div className="positionexp">  </div>
            <div className="durationexp"> March 2020 </div>
		</div>
    </div>
		<div class="back">
            
        <div className="contentexp"> 
     <b>Project Link:</b> <a href="https://github.com/jb1998/DPAI">click here</a><br></br>
     <b>Tech Stack:- Android app, Java, Python, Machine learning, Firebase realtime database</b> 
        <br></br>
        AIM-1: To predict diseases[COVID-19, Heart problem, Diabetes] using AI models.<br></br>
        AIM-2: To provide the latest information on diseases from trusted sources including news channels like The times of India
		</div>
		</div>
	</div>
</div>
</div>


<div className="boxeach">
  
  <div  class="flip-container" ontouchstart="this.classList.toggle('hover');">
<div class="flipper" >
  <div class="front " >
  <div className="msit"></div>
 <div className="halfflipcard">
  <div className="headingexp"> "MSIT Connect" </div>
  
      <div className="positionexp"> *Published in Playstore </div>
      <div className="durationexp"> December 2018 - March 2020 </div>
  </div>
  </div>
  <div class="back">
      
  <div className="contentexp"> 
<b>Project Link:</b> <a href="https://play.google.com/store/apps/details?id=com.jatin.placementconnect">click here</a><br></br>
<b>Tech Stack:- Android app, Java, Firebase realtime database, authentication</b> 
  <br></br>
  <b><i>*4.75 Playstore ratings, 250+ downloads</i></b><br></br>
  AIM-1: The app connects seniors/alumni and juniors of IP University, India.<br></br>
  AIM-2: The app gives realtime notifications of placements, events, timetable for all engineering students.
  </div>
  </div>
</div>
</div>
</div>



<div className="boxeach">
  
  <div  class="flip-container" ontouchstart="this.classList.toggle('hover');">
<div class="flipper" >
  <div class="front" >
  <div className="covid"></div>
 <div className="halfflipcard">
  <div className="headingexp"> "Modified COVID-19 Dataset for Automatic Prediction" </div>
  
      <div className="positionexp"> </div>
      <div className="durationexp"> April 2020 - August 2020 </div>
  </div>
  </div>
  <div class="back">
      
  <div className="contentexp"> 
<b>Project Link:</b> <a href="https://github.com/jb1998/COVID-19">click here</a><br></br>
<b>Tech Stack:- Python, Machine Learning, Data Analysis</b> 
  <br></br>
  AIM: Cleaned completely raw data of covid19, did analysis and applied Machine Learning to predict the risk<br></br>
  Research paper accepted in International Journal of Intelligent Engineering Informatics
  </div>
  </div>
</div>
</div>
</div>

<div className="boxeach">
  
  <div  class="flip-container" ontouchstart="this.classList.toggle('hover');">
<div class="flipper" >
  <div class="front " >
  <div className="interactive"></div>
 <div className="halfflipcard">
  <div className="headingexp"> "Interactive CV" </div>
  
      <div className="positionexp">*Published on playstore  </div>
      <div className="durationexp"> Aug 2017 - Nov 2017 </div>
  </div>
  </div>
  <div class="back">
      
  <div className="contentexp"> 
<b>Project Link:</b> <a href="https://play.google.com/store/apps/details?id=com.dev.jatin.interactive_cv">click here</a><br></br>
<b>Tech Stack:- Android development, Java, Animations, Firebase</b> 
  <br></br>
  Made my resume in the form of an Interactive android app with
animations, authentication, and real-time firebase database.
  </div>
  </div>
</div>
</div>
</div>
<div className="boxeach">
  
  <div  class="flip-container" ontouchstart="this.classList.toggle('hover');">
<div class="flipper" >
  <div class="front " >
  <div className="remind"></div>
 <div className="halfflipcard">
  <div className="headingexp"> "Remind-it" </div>
  
      <div className="positionexp">*Published on playstore </div>
      <div className="durationexp"> June 2017 - Aug 2017 </div>
  </div>
  </div>
  <div class="back">
      
  <div className="contentexp"> 
<b>Project Link:</b> <a href="https://github.com/jb1998/Remind_it">click here</a><br></br>
<b>Tech Stack:- Android development, Java, Animations, SQLite</b> 
  <br></br> Todo app with push notification alerts, sound alerts, add/delete/modify features
  </div>
  </div>
</div>
</div>
</div>



</div>

 
        </div>

    
       
        
 
    )
    }

export default Projects;